import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HomeworkActivityQuery, HomeworkActivityService } from '@examdojo/homework';
import { QuestionAttemptEntityService } from '@examdojo/question';
import { EMPTY, switchMap } from 'rxjs';

@Injectable()
export class SyncProgressAfterGradingEffect {
  constructor(
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly homeworkActivityQuery: HomeworkActivityQuery,
    private readonly homeworkActivityService: HomeworkActivityService,
  ) {
    this.syncProgressAfterGrading().pipe(takeUntilDestroyed()).subscribe();
  }

  private syncProgressAfterGrading() {
    return this.questionAttemptService.attemptGraded$.pipe(
      switchMap(() => {
        const ongoingActivity = this.homeworkActivityQuery.getOngoingActivity();
        if (!ongoingActivity) {
          return EMPTY;
        }
        return this.homeworkActivityService.fetchProgress(ongoingActivity.id);
      }),
    );
  }
}
